import { FieldValues } from "react-hook-form";

const normalizeContractLanguage = (value: unknown): string | null => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? value : null;
};

export const mapFormToRequestBody = (props: FieldValues) => {
  const contractLanguage = normalizeContractLanguage(props.contractLanguage);
  if (props.isDefault) {
    return {
      cptCodes: props.cptCodes,
      discountPercentForRank2: Number(props.discountPercentForRank2),
      discountPercentForRank3: Number(props.discountPercentForRank3),
      discountPercentForRank4: Number(props.discountPercentForRank4),
      discountPercentForRank5Plus: Number(props.discountPercentForRank5Plus),
      groupName: props.groupName,
      allowOnDuplicateCptCodes: props.allowOnDuplicateCptCodes,
      duplicateNotPaid: props.duplicateNotPaid,
      isDefault: true,
      contractLanguage,
    };
  }
  return {
    cptCodes: props.cptCodes,
    discountPercentForRank2: Number(props.discountPercentForRank2),
    discountPercentForRank3: Number(props.discountPercentForRank3),
    discountPercentForRank4: Number(props.discountPercentForRank4),
    discountPercentForRank5Plus: Number(props.discountPercentForRank5Plus),
    groupName: props.groupName,
    providerId: props.provider.value,
    payerId: props.payerName.value,
    allowOnDuplicateCptCodes: props.allowOnDuplicateCptCodes,
    duplicateNotPaid: props.duplicateNotPaid,
    contractLanguage,
  };
};

export const mapCaseRateFormToRequestBody = (props: FieldValues) => {
  const contractLanguage = normalizeContractLanguage(props.contractLanguage);
  if (props.isDefault) {
    return {
      cptCodes: props.cptCodes,
      groupName: props.groupName,
      excludedCptCodes: props.excludedCptCodes,
      isPerDiem: props.isPerDiem ?? false,
      isBilateral: props.isBilateral ?? false,
      isDefault: true,
      contractLanguage,
    };
  }
  return {
    cptCodes: props.cptCodes,
    groupName: props.groupName,
    providerId: props.provider.value,
    payerId: props.payerName.value,
    excludedCptCodes: props.excludedCptCodes,
    isPerDiem: props.isPerDiem ?? false,
    isBilateral: props.isBilateral ?? false,
    contractLanguage,
  };
};

export const mapPackagesFormToRequestBody = (props: FieldValues) => {
  const contractLanguage = normalizeContractLanguage(props.contractLanguage);
  if (props.isDefault) {
    return {
      triggerCptCodes: props.triggerCptCodes,
      bundledCptCodes: props.bundledCptCodes,
      groupName: props.groupName,
      isDefault: true,
      contractLanguage,
    };
  }
  return {
    triggerCptCodes: props.triggerCptCodes,
    bundledCptCodes: props.bundledCptCodes,
    groupName: props.groupName,
    providerId: props.provider.value,
    payerId: props.payerName.value,
    contractLanguage,
  };
};

export const getRulesetList = (data: any, addDiscounts = true) => {
  const result = [] as any[];
  const { allowOnDuplicateCptCodes, duplicateNotPaid } = data;
  const discountsToAdd = {
    discountPercentForRank2: data.discountPercentForRank2,
    discountPercentForRank3: data.discountPercentForRank3,
    discountPercentForRank4: data.discountPercentForRank4,
    discountPercentForRank5Plus: data.discountPercentForRank5Plus,
  };
  // Default rules have no provider/payer cross-product — emit a single entry.
  if (data.isDefault) {
    result.push({
      isDefault: true,
      groupName: data.groupName,
      cptCodes: data.cptCodes,
      excludedCptCodes: data.excludedCptCodes,
      isPerDiem: data.isPerDiem,
      isBilateral: data.isBilateral,
      triggerCptCodes: data.triggerCptCodes,
      bundledCptCodes: data.bundledCptCodes,
      allowOnDuplicateCptCodes,
      duplicateNotPaid,
      contractLanguage: data.contractLanguage,
      ...(addDiscounts && discountsToAdd),
    });
    return result;
  }
  const providers = data.provider;
  const payers = data.payerName;
  providers.forEach((provider: any) => {
    payers.forEach((payer: any) => {
      const newObj = {
        provider: {
          name: provider.name,
          value: provider.value,
        },
        payerName: {
          name: payer.name,
          value: payer.value,
        },
        groupName: data.groupName,
        cptCodes: data.cptCodes,
        excludedCptCodes: data.excludedCptCodes,
        isPerDiem: data.isPerDiem,
        isBilateral: data.isBilateral,
        triggerCptCodes: data.triggerCptCodes,
        bundledCptCodes: data.bundledCptCodes,
        allowOnDuplicateCptCodes,
        duplicateNotPaid,
        contractLanguage: data.contractLanguage,
        ...(addDiscounts && discountsToAdd),
      };
      result.push(newObj);
    });
  });
  return result;
};
